import { useContext } from "react";
import { DealerCompanyContext } from "../context";

export const useDealerCompany = () => useContext(DealerCompanyContext);